import type {RuleValidationErrors} from '../types';
import type {KeywordRule} from './types';
import {createValidationObject} from '../../utils/createValidationObject';

export const validateKeywordRule = <T extends KeywordRule = KeywordRule>(
	rule: T,
): RuleValidationErrors | false => {
	if (rule.elementValue1 === '') {
		return {
			elementValue1: createValidationObject(),
		};
	}
	return false;
};

export default validateKeywordRule;
